import { AbstractConnector } from '@web3-react/abstract-connector';
import { BinanceWallet, Injected, WalletConnect, MathWallet, Onto, BitKeep } from './connectors';

export interface IWallet {
    name: string,
    image: string,
    connector: AbstractConnector
}

export const WALLETS: IWallet[] = [
    {
        name: "Metamask",
        image: "metamask.svg",
        connector: Injected
    },
    {
        name: "Binance Chain Wallet",
        image: "binance.png",
        connector: BinanceWallet
    },
    {
        name: "Wallet Connect",
        image: "wallet_connect.png",
        connector: WalletConnect
    },
    {
        name: "Trust Wallet",
        image: "trust_wallet.png",
        connector: Injected
    },
    {
        name: "Bitkeep",
        image: "bitkeep.svg",
        connector: BitKeep,
    },
    {

        name: "Onto",
        image: "onto.png",
        connector: Onto,
    },
    {
        name: "Math",
        image: "math_wallet.png",
        connector: MathWallet,
    }
]